import React from 'react';
import './style.css';
import { Truck } from './truck'
import { Mouse } from './mouse'
import { Heart } from './heart'
import { Gallery } from '../../Shared/Modals/AboutUsMobile/components/HowToPurchase/gallery';
import { HowToPurchaseItem } from './HowToPurchaseItem';

const HowToPurchaseItemData = [
    {
        icon: <Gallery />,
        title: 'בחרו את התמונות שלכם',
        description: 'תרכזו את התמונות שתרצו לקבל, אנחנו נתריע לכם מראש על כל תמונה שלא מתאימה להדפסה',
        number: 1
    },
    {
        icon: <Mouse />,
        title: 'סמנו את סוג המסגרת',
        description: 'בחרו את סוג המסגרת על פי טעמכם עם הדמייה של התמונות שבחרתם',
        number: 2
    },
    {
        icon: <Truck />,
        title: 'אשרו כתובת למשלוח',
        description: 'הכניסו את פרטי המשלוח באיזור הקופה, משלוח עד פתח הבית',
        number: 3
    },
    {
        icon: <Heart />,
        title: 'עצבו קיר מושלם בקלות',
        description: 'המסגרות פשוט נדבקות לקיר, כל קיר הופך לקיר מלא בזכרונות נעימים',
        number: 4
    }
]

export const HowToPurchase = () => {
  return (
    <div className="htp-section">
      <div className="htp-header">
        <span className="htp-label">איך זה עובד</span>
        <h2 className="htp-title">כיצד לרכוש בבלנדס</h2>
      </div>

      <div className="htp-timeline">
        <div className="htp-timeline-line" />
        {HowToPurchaseItemData.map((item, index) => (
          <HowToPurchaseItem
            key={item.number}
            icon={item.icon}
            number={item.number}
            title={item.title}
            description={item.description}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};
